import { createApp } from 'vue'
import mitt from 'mitt'
import ModuleView from '@vueapp/views/Module.vue'



export class Module {
    constructor( elements ) {
        if ( elements ) {
            elements.forEach(function (item, key) {
                const emitter = mitt()
                const app = createApp(ModuleView, {
                    postId: item.getAttribute('data-post-id'),
                    postSlug: item.getAttribute('data-post-slug')
                })
                app.config.globalProperties.emitter = emitter
                app.mount('#' + item.getAttribute('id') )
            });
        }
    }
}
